import z from "zod";

enum MediaType {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
};

export const CompanyMediaSchema = z.object({
    id: z.string(),
    type: z.nativeEnum(MediaType),
    objectKey: z.string().min(1),
});
export type CompanyMediaDTO = z.infer<typeof CompanyMediaSchema>;